"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SipSubConnection = exports.SipAnswer = exports.SipOffer = void 0;
/* tslint:disable:max-classes-per-file */
const Connection_1 = require("./Connection");
const Tracks_1 = require("./Tracks");
const Listener_1 = require("./Listener");
class SipOffer extends Connection_1.Offer {
}
exports.SipOffer = SipOffer;
class SipAnswer extends Connection_1.Answer {
}
exports.SipAnswer = SipAnswer;
class SipConnection extends Listener_1.default {
    constructor(signaling, configuration) {
        super();
        this.state = new Connection_1.StateConnecting(new Event(""));
        this.remoteTracks = {};
        this.ctx = new AudioContext();
        this.participants = new Map();
        this.createConnection = (participantId) => {
            const subConnection = new SipSubConnection(participantId, this);
            this.participants.set(participantId, subConnection);
            return subConnection;
        };
        this.connection = new Connection_1.default(signaling, Object.assign(Object.assign({}, configuration), { sendIceWithSdp: true }), false, true);
        const overrideOn = signaling.on;
        signaling.on = (signal) => {
            if (signal instanceof Connection_1.Offer) {
                signaling.emit(new SipOffer(signal.sdp));
            }
            else if (signal instanceof Connection_1.Answer) {
                signaling.emit(new SipAnswer(signal.sdp));
            }
            overrideOn(signal);
        };
        this.connection.on((event) => {
            if (event instanceof Connection_1.StateChangeEvent) {
                this.state = event;
            }
            this.fire(event);
        });
    }
    negotiate(offerTracks, requestRemoteTracks) {
        return __awaiter(this, void 0, void 0, function* () {
            const offerAudioTracks = offerTracks === null || offerTracks === void 0 ? void 0 : offerTracks.filter((t) => t.type === Tracks_1.TrackType.AUDIO);
            const requestAudioTracks = requestRemoteTracks === null || requestRemoteTracks === void 0 ? void 0 : requestRemoteTracks.filter((t) => t === Tracks_1.TrackType.AUDIO);
            if (offerAudioTracks != null) {
                if (offerAudioTracks.length === 0) {
                    const oscillator = this.ctx.createOscillator();
                    const dst = oscillator.connect(this.ctx.createMediaStreamDestination());
                    oscillator.start();
                    // @ts-ignore
                    const audio = dst.stream.getAudioTracks()[0];
                    audio.enabled = false;
                    offerAudioTracks.push(new Tracks_1.Track(Tracks_1.TrackType.AUDIO, audio));
                }
                else {
                    const oldDummyTrack = this.connection.offeringTracks.find((t) => t.track.enabled === false);
                    if (oldDummyTrack) {
                        oldDummyTrack.stop();
                    }
                }
            }
            return yield this.connection.negotiate(offerAudioTracks, requestAudioTracks);
        });
    }
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            return Promise.reject("You are not allowed to connect to sip!. Please wait for sip offer.");
        });
    }
    close() {
        clearInterval(this.restartIceInterval);
        this.connection.close();
    }
    isClosed() {
        return this.connection.isClosed();
    }
    getStats(selector) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.connection.getStats(selector);
        });
    }
}
exports.default = SipConnection;
class SipSubConnection extends Listener_1.default {
    constructor(participantId, connection) {
        super();
        this.state = new Connection_1.StateConnecting(new Event(""));
        this.participantId = participantId;
        this.connection = connection;
        this.state = this.connection.state;
        this.connection.on((event) => {
            if (event instanceof Connection_1.StateChangeEvent) {
                this.state = event;
            }
            this.fire(event);
        });
    }
    negotiate(offerTracks, requestRemoteTracks) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.connection.negotiate(offerTracks, requestRemoteTracks);
        });
    }
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            return Promise.reject("You are not allowed to connect to sip!. Please wait for sip offer.");
        });
    }
    close() {
        this.connection.participants.delete(this.participantId);
    }
    isClosed() {
        return this.connection.isClosed();
    }
    getStats(selector) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.connection.getStats(selector);
        });
    }
}
exports.SipSubConnection = SipSubConnection;
//# sourceMappingURL=SipConnection.js.map